// extracted by mini-css-extract-plugin
module.exports = {"languageIcon":"language-icon_languageIcon__3GbuT","greycat":"language-icon_greycat__3cSFn","typescript":"language-icon_typescript__2R0yy"};